
import { defineComponent } from 'vue'
import Breadcrumb from 'primevue/breadcrumb'
import Dialog from 'primevue/dialog'
import resourceManagementDescriptor from './ResourceManagementDescriptor.json'

export default defineComponent({
    name: 'import-file-dialog',
    components: { Breadcrumb, Dialog },
    props: {
        visibility: Boolean,
        path: String
    },
    emits: ['update:visibility', 'createFolder'],
    data() {
        return {
            descriptor: resourceManagementDescriptor,
            home: { icon: 'pi pi-home' },
            items: [] as Array<{ label: String }>,
            folderName: '',
            loading: false
        }
    },
    mounted() {
        this.setBreadcrumbs()
        this.folderName = ''
    },
    methods: {
        closeDialog(): void {
            this.folderName = ''
            this.$emit('update:visibility', false)
        },
        emitCreateFolder(): void {
            this.$emit('createFolder', this.folderName)
            this.folderName = ''
        },
        setBreadcrumbs() {
            this.folderName = ''
            this.items = []

            if (this.path) {
                let pathFolders = this.path.split('\\', -1)
                pathFolders.forEach((element) => {
                    let obj = { label: element }
                    this.items.push(obj)
                })
            }
        }
    },
    watch: {
        path(oldPath, newPath) {
            if (oldPath != newPath) this.setBreadcrumbs()
        }
    }
})
